import React from "react";

const BeeAI = () => {
  return (
    <div style={{ marginTop: "80px", width: "100%", height: "100vh" }}>
      <iframe
        src="https://taerimk-beeai.hf.space"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="BeeAI"
      />
    </div>
  );
};

export default BeeAI;